import styled from 'styled-components';
import { Flex } from 'onefaceui-react-components';

export const Container = styled(Flex)`
  position: absolute;
  z-index: 999;
  background: #263645 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #0000003D;
  border-radius: 2px;
  opacity: 0.95;
  padding: 8px 12px;
  width: 334px;
  top: 40px;
  left: 8px;

  @media screen and (max-width: 1170px) {
    top: 80px;
  }
`;
